import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { BadgesLevels, CopyLink, RowSelectorTd, Status } from 'components/misc'
import { Data, Table } from 'components/layout/Table'
import { participants as participantsLayout } from 'constants/layout'
import { Export } from 'containers/misc'
import { BulkChangeParticipants } from 'containers/bulkChange'
import { FormattedMessage } from 'react-intl'
import config from 'config'
import get from 'lodash/get'
import { ACTIVITY_SECTIONS, CONFIGURATION_KEYS } from '../../../../constants/enums'
import { initialize } from 'redux-form'
import { getLabels } from '../../../../helpers/labelHelper'

export default class ParticipantsTable extends PureComponent {
  static propTypes = {
    participants: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    organizationHierarchyId: PropTypes.number,
    setParticipantsParams: PropTypes.func,
    exportParticipants: PropTypes.func.isRequired,
    setParticipantSelectedTo: PropTypes.func.isRequired,
    selectableParticipantIds: PropTypes.array,
    areAllParticipantsSelected: PropTypes.bool,
    bulkSelectParticipants: PropTypes.func,
    showLastActivity: PropTypes.bool,
    setCommonLimit: PropTypes.func,
    initialize: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    isAssessorParticipants: PropTypes.func.bool,
    isAssessorActivityParticipants: PropTypes.func.bool,
    isAssessorAJParticipants: PropTypes.func.bool,
    isAssessorRPParticipants: PropTypes.func.bool
  }
  static defaultProps = {
    permissions: {},
    isAssessorParticipants: false,
    isAssessorActivityParticipants: false,
    isAssessorAJParticipants: false,
    isAssessorRPParticipants: false
  }

  getOrganizationLink = data => {
    if (data.gold.name) {
      return <Link to={`${config.publicPath}/award-units/${data.gold.id}/detail`}>{data.gold.name}</Link>
    } else if (data.silver.name) {
      return <Link to={`${config.publicPath}/award-units/${data.silver.id}/detail`}>{data.silver.name}</Link>
    }

    return <Link to={`${config.publicPath}/award-units/${data.bronze.id}/detail`}>{data.bronze.name}</Link>
  }

  addLabelToFilter = label => {
    let initValues = []

    initValues.push({ value: label.id, label: label.name })
    this.props.dispatch(initialize(
      'participants-filter',
      { 'labels_label_id@or' : initValues }
    ))
    this.props.setFilter(`labels.label.id=${label.id}`)
  }

  addAwardLabelToFilter = label => {
    let initValues = []

    initValues.push({ value: label.id, label: label.name })
    this.props.dispatch(initialize(
      'participants-filter',
      { 'awards_labels_label_id@or' : initValues }
    ))
    this.props.setFilter(`awards.labels.label.id=${label.id}`)
  }

  getTypeOfActivity = () => {
    const {
      isAssessorActivityParticipants,
      isAssessorAJParticipants,
      isAssessorRPParticipants
    } = this.props

    if (isAssessorActivityParticipants) {
      return [ACTIVITY_SECTIONS.physical.id,
        ACTIVITY_SECTIONS.skills.id,
        ACTIVITY_SECTIONS.service.id
      ]
    }

    if (isAssessorAJParticipants) {
      return [ACTIVITY_SECTIONS.aj.id]
    }

    if (isAssessorRPParticipants) {
      return [ACTIVITY_SECTIONS.rp.id]
    }
  }

  getAssessorActivities = (assessorActivities, pid) => {
    const assessorId = get(this.props, 'params.assessorId')

    const assessorActivityMap = get(assessorActivities, 'assessorActivityMap')

    const activities = assessorActivityMap && assessorActivityMap[assessorId]

    let activityLinkList = []

    const filteredActivities = activities && activities.filter(a => this.getTypeOfActivity().includes(get(a, 'section')))

    filteredActivities && filteredActivities.forEach(a => {
      const level = `${get(a, 'award')}-level`.toLowerCase()
      let section = get(a, 'section')

      if (get(a, 'section') === ACTIVITY_SECTIONS.physical.id) {
        section = ACTIVITY_SECTIONS.physical.link
      }  else if (get(a, 'section') === ACTIVITY_SECTIONS.aj.id) {
        section = ACTIVITY_SECTIONS.aj.link
      } else if (get(a, 'section') === ACTIVITY_SECTIONS.rp.id) {
        section = ACTIVITY_SECTIONS.rp.link
      } else {
        section = section.toLowerCase()
      }

      activityLinkList.push(<Link to={`${config.publicPath}/participants/${pid}/${level}/${section}`}>{get(a, 'activityName')}</Link>)
      if (activityLinkList.length > 0) {
        activityLinkList.push(<br />)
      }
    })

    return activityLinkList
  }

  render() {
    const {
      selectableParticipantIds: selectableIds,
      permissions,
      setParticipantsParams,
      areAllParticipantsSelected,
      bulkSelectParticipants,
      organizationHierarchyId,
      setParticipantSelectedTo,
      showLastActivity,
      setCommonLimit,
      participants,
      configuration,
      activeOrganization,
      isAssessorParticipants,
      isAssessorActivityParticipants,
      isAssessorAJParticipants,
      isAssessorRPParticipants
    } = this.props

    let loading = get(participants, 'loading')
    let list = get(participants, 'list')
    let offset = get(participants, 'offset')
    let limit = get(participants, 'limit')
    let pages = get(participants, 'pages')
    let sort = get(participants, 'sort')
    let selectedIds = get(participants, 'selectedIds')

    if (isAssessorParticipants) {
      if (isAssessorActivityParticipants) {
        loading = get(participants, 'assessor.activity.loading')
        list = get(participants, 'assessor.activity.list')
        offset = get(participants, 'assessor.activity.offset')
        limit = get(participants, 'assessor.activity.limit')
        pages = get(participants, 'assessor.activity.pages')
        sort = get(participants, 'assessor.activity.sort')
        selectedIds = get(participants, 'assessor.activity.selectedIds')
      }

      if (isAssessorAJParticipants) {
        loading = get(participants, 'assessor.aj.loading')
        list = get(participants, 'assessor.aj.list')
        offset = get(participants, 'assessor.aj.offset')
        limit = get(participants, 'assessor.aj.limit')
        pages = get(participants, 'assessor.aj.pages')
        sort = get(participants, 'assessor.aj.sort')
        selectedIds = get(participants, 'assessor.aj.selectedIds')
      }

      if (isAssessorRPParticipants) {
        loading = get(participants, 'assessor.rp.loading')
        list = get(participants, 'assessor.rp.list')
        offset = get(participants, 'assessor.rp.offset')
        limit = get(participants, 'assessor.rp.limit')
        pages = get(participants, 'assessor.rp.pages')
        sort = get(participants, 'assessor.rp.sort')
        selectedIds = get(participants, 'assessor.rp.selectedIds')
      }
    }

    const safeSelectedIds = selectedIds || []

    const isLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)

    const isAwardLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableAwardLabels.id}].booleanValue`)

    const ExportComponent = (
      <Export
        exportName="Participants"
        toExport={this.props.exportParticipants}
        exportSchemeValue="participants"
        count={participants && participants.count}
      />
    )

    return (
      <div>
        {!isAssessorParticipants && <BulkChangeParticipants selectedIds={safeSelectedIds} />}

        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={participantsLayout.tableHeaders({ organizationHierarchyId, showLastActivity, isLabelsEnabled, isAwardLabelsEnabled, isAssessorParticipants })}
          areAllSelected={areAllParticipantsSelected ? true : undefined}
          bulkSelect={() => bulkSelectParticipants(safeSelectedIds, selectableIds)}
          setParams={setParticipantsParams}
          permissions={permissions}
          exportComponent={isAssessorParticipants ? null : ExportComponent}
        >

          <Data>
            {list.map(
              ({
                 id,
                 globalId,
                 firstName,
                 lastName,
                 email,
                 personState,
                 currentAwardLeaderName,
                 currentAwardLeaderId,
                 goldAwardOrganizationId,
                 silverAwardOrganizationId,
                 bronzeAwardOrganizationId,
                 goldAwardOrganizationName,
                 silverAwardOrganizationName,
                 bronzeAwardOrganizationName,
                 goldAwardNaoIcLevelOrganizationParentName,
                 silverAwardNaoIcLevelOrganizationParentName,
                 bronzeAwardNaoIcLevelOrganizationParentName,
                 goldAwardState,
                 silverAwardState,
                 bronzeAwardState,
                 lastActivityDate,
                 isLastAwardOffline,
                 assessorActivities,
                 awardLabels,
                 labels
               }) => {
                return (
                  <tr key={id}>
                    <RowSelectorTd
                      enabled={selectableIds && selectableIds.includes(id) ? true : undefined}
                      selected={selectedIds && selectedIds.includes(id) ? true : undefined}
                      setSelected={val => setParticipantSelectedTo(id, val)}
                    />
                    <td>
                      <Link
                        to={{ pathname: `${config.publicPath}/participants/${id}/detail` }}
                      >
                        {globalId}
                      </Link>
                    </td>
                    <td>{firstName}</td>
                    <td>{lastName}</td>
                    <td>{email} {email && <CopyLink text={email} />}</td>

                    <td>
                      <BadgesLevels
                        hasGold={Boolean(goldAwardOrganizationId)}
                        hasSilver={Boolean(silverAwardOrganizationId)}
                        hasBronze={Boolean(bronzeAwardOrganizationId)}
                        participantId={id}
                        small
                      />
                    </td>
                    {showLastActivity &&
                      <td>
                        {/* eslint-disable-next-line no-nested-ternary */}
                        {isLastAwardOffline ? <FormattedMessage
                          id="logs.offline"
                          defaultMessage="Offline"
                        /> : (lastActivityDate
                          ? moment(lastActivityDate).fromNow()
                          : <FormattedMessage
                            id="logs.no_logs"
                            defaultMessage="No logs"
                          />)
                        }
                      </td>
                    }
                    {isAssessorParticipants && <td>
                      {assessorActivities && this.getAssessorActivities(assessorActivities, id)}
                    </td> }
                    {isLabelsEnabled && <td>
                      {labels && getLabels(labels, this.addLabelToFilter)}
                    </td> }
                    {isAwardLabelsEnabled && <td>
                      {awardLabels && getLabels(awardLabels, this.addAwardLabelToFilter)}
                    </td> }
                    <td>
                      {currentAwardLeaderId ? (
                        <Link to={`${config.publicPath}/leaders/${currentAwardLeaderId}/detail`}>
                          {currentAwardLeaderName}
                        </Link>
                      ) : (
                        '---'
                      )}
                    </td>
                    {(permissions.isIf || permissions.isNaoStaff) && (
                      <td>
                        {
                          this.getOrganizationLink({
                            gold: {
                              id: goldAwardOrganizationId,
                              name: goldAwardOrganizationName
                            }, silver: {
                              id: silverAwardOrganizationId,
                              name: silverAwardOrganizationName
                            },
                            bronze: {
                              id: bronzeAwardOrganizationId,
                              name: bronzeAwardOrganizationName
                            } })
                        }
                      </td>
                    )}
                    {permissions.isIf && (
                      <td>
                        {goldAwardNaoIcLevelOrganizationParentName ||
                          silverAwardNaoIcLevelOrganizationParentName ||
                          bronzeAwardNaoIcLevelOrganizationParentName}
                      </td>
                    )}
                    <td>
                      <Status state={personState} />
                      <br />
                      <small>
                        {(goldAwardState && goldAwardState.translationText) ||
                          (silverAwardState &&
                            silverAwardState.translationText) ||
                          (bronzeAwardState &&
                            bronzeAwardState.translationText)}
                      </small>
                    </td>
                  </tr>
                )
              }
            )}
          </Data>
        </Table>
      </div>
    )
  }
}
